export default function Contact() {
    return (
        <div className="relative">

            {/* ===== HERO + CONTACT SECTION ===== */}
            <div
                className="relative bg-cover bg-center min-h-screen flex items-center justify-center"
                style={{
                    backgroundImage: "url('/images/spices-bg.jpg')",
                }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/70"></div>

                {/* CONTENT */}
                <div className="relative z-10 w-full max-w-3xl px-6">

                    {/* HERO TEXT BOX */}
                    <div className="bg-black/60 backdrop-blur-md p-8 md:p-10 rounded-2xl text-center mb-10 shadow-xl">
                        <h1 className="text-4xl md:text-5xl font-extrabold text-white">
                            संपर्क करें
                        </h1>
                        <p className="mt-4 text-white/90 leading-relaxed">
                            थोक ऑर्डर, डीलरशिप या उत्पाद की जानकारी के लिए कॉल /
                            WhatsApp करें या नीचे दिए गए संपर्क विवरण का उपयोग करें।
                        </p>
                    </div>

                    {/* CONTACT DETAILS BOX */}
                    <div className="bg-black/60 backdrop-blur-md rounded-2xl p-8 md:p-10 shadow-xl">

                        <h2 className="text-center text-3xl font-extrabold text-white mb-8">
                            📞 संपर्क नंबर
                        </h2>

                        <div className="space-y-6">

                            {/* Card 1 */}
                            <div className="flex justify-between items-center bg-white/10 p-5 rounded-xl hover:bg-white/20 transition duration-300">
                                <div>
                                    <p className="font-bold text-lg text-white">
                                        श्री हरिओम शर्मा
                                    </p>
                                    <p className="text-sm text-white/80">
                                        Sales / Orders
                                    </p>
                                </div>
                                <a
                                    href="tel:9993002880"
                                    className="font-bold text-[#ffd700] text-lg"
                                >
                                    +91 9752772880
                                </a>
                            </div>

                            {/* Card 2 */}
                            <div className="flex justify-between items-center bg-white/10 p-5 rounded-xl hover:bg-white/20 transition duration-300">
                                <div>
                                    <p className="font-bold text-lg text-white">
                                        श्री नवीन शर्मा
                                    </p>
                                    <p className="text-sm text-white/80">
                                        Dealer Enquiry
                                    </p>
                                </div>
                                <a
                                    href="tel:9981435600"
                                    className="font-bold text-[#ffd700] text-lg"
                                >
                                    +91 9981435600
                                </a>
                            </div>

                            {/* Card 3 */}
                            <div className="flex justify-between items-center bg-white/10 p-5 rounded-xl hover:bg-white/20 transition duration-300">
                                <div>
                                    <p className="font-bold text-lg text-white">
                                        श्री ध्रुव शर्मा
                                    </p>
                                    <p className="text-sm text-white/80">
                                        Support & Management
                                    </p>
                                </div>
                                <a
                                    href="tel:9893359184"
                                    className="font-bold text-[#ffd700] text-lg"
                                >
                                    +91 9893359184
                                </a>
                            </div>

                        </div>

                        {/* EMAIL */}
                        <div className="text-center mt-10">
                            <p className="text-white text-xl font-semibold mb-2">
                                ✉️ ईमेल
                            </p>
                            <a
                                href="mailto:info@balajimasale.com"
                                className="text-[#ffd700] underline font-medium text-lg"
                            >
                                shribalajimirchibandar@gmail.com
                            </a>
                        </div>

                    </div>

                </div>
            </div>

        </div>
    );
}
